import React, { useContext, useEffect } from "react";

/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Dashboard2 from "./components/Dashboard/Dashboard2";
import Dashboard3 from "./components/Dashboard/Dashboard3";
import Dashboard4 from "./components/Dashboard/Dashboard4";
import Dashboard5 from "./components/Dashboard/Dashboard5";

//Trading
import Market from "./components/Trading/Market";
import IcoListing from "./components/Trading/IcoListing";
import P2P from "./components/Trading/P2P";
import Future from "./components/Trading/Future";
import IntradayTrading from "./components/Trading/IntradayTrading";

//Crypto
import MarketWatch from "./components/Crypto/MarketWatch";
import IcoListingFilter from "./components/Crypto/IcoListingFilter";
import Banking from "./components/Crypto/Banking";
import Exchange from "./components/Crypto/Exchange";
import CoinDetails from "./components/Crypto/CoinDetails";

//Report
import History from "./components/Report/History";
import Order from "./components/Report/Order";
import Reports from "./components/Report/Reports";
import User from "./components/Report/User";
import Contact from "./components/Report/Contact";
import Activity from "./components/Report/Activity";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import SignUp from "./pages/Registration";
import ForgotPassword from "./pages/ForgotPassword";
import Login from "./pages/Login";

/// ADMIN PAGES
import UsersTable from "./components/Admin/Users";
import CoinsTable from "./components/Admin/Coins";
import TransactionsTable from "./components/Admin/Transactions";
import PromoCodesTable from "./components/Admin/PromoCode";
import { ThemeContext } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";
import { getUserProfile } from "../api/auth";
import ManageCoinsPriceTable from "./components/Admin/ManageCoinPrice";
import Portfolio from "./components/Admin/Portfolio";
import CardBlog from "./components/Admin/CardBlog";

import Settings from "./components/Admin/Settings";
import Statement from "./components/Admin/Statement";
import FundsHistory from "./components/Admin/FundsHistory";
import DashboardSettings from "./components/Admin/DashboardSettings";
import DashBoardEntries from "./components/Admin/DashBoardEntry";
import UserTrade from "./components/Admin/CommanPage/userTrade";
import WithdrawRequests from "./components/Admin/WithdrawRequests";
import DepositEntry from "./components/Admin/DepositEntry";

const Markup = () => {
  const token = localStorage?.getItem("token");
  const { user, setUser } = useAuth();

  const getAndSetUser = async () => {
    const userData = await getUserProfile();
    setUser(userData || {});
  };
  useEffect(() => {
    if (token) {
      getAndSetUser();
    }
  }, [token]);

  const allroutes = [
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "portfolio", component: <Portfolio /> },
    { url: "funds-history", component: <FundsHistory /> },
    { url: "trade", component: <UserTrade/> },

    // { url: "dashboard-dark", component: <DashboardDark /> },
    // { url: "index-1", component: <Dashboard2 /> },
    // { url: "index-3", component: <Dashboard3 /> },
    // { url: "index-4", component: <Dashboard4 /> },
    // { url: "index-5", component: <Dashboard5 /> },

    // //Trading
    { url: "market", component: <Market /> },
    // { url: "ico-listing", component: <IcoListing /> },
    // { url: "p2p", component: <P2P /> },
    { url: "statement", component: <Statement /> },
    // { url: "future", component: <Future /> },
    { url: "intraday-trading", component: <IntradayTrading /> },

    //Crypto
    { url: "", component: <MarketWatch /> },
    // { url: "crypto", component: <MarketWatch /> },
    { url: "ico-listing", component: <IcoListingFilter /> },
    // { url: "banking", component: <Banking /> },
    { url: "exchange", component: <Exchange /> },
    { url: "/coin-details/:coinId", component: <CoinDetails /> },

    //Report
    { url: "history", component: <History /> },
    { url: "orders", component: <Order /> },
    { url: "reports", component: <Reports /> },
    { url: "user", component: <User /> },
    { url: "contact", component: <Contact /> },
    { url: "activity", component: <Activity /> },

    /// Apps
    { url: "app-profile", component: <EditProfile /> },
    // { url: "edit-profile", component: <EditProfile /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    { url: "post-details", component: <PostDetails /> },

    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <Customers /> },
    //
    ///// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },
    //
    ///// Bootstrap
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },

    ///// Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-noui-slider", component: <MainNouiSlider /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "map-jqvmap", component: <JqvMap /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },

    ///// Widget
    { url: "widget-basic", component: <Widget /> },

    ///// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },

    ///// table
    { url: "table-filtering", component: <FilteringTable /> },
    { url: "table-sorting", component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },
  ];

  const adminRoutes = [
    ///// ADMIN ROUTES
    { url: "admin-users", component: <UsersTable /> },
    { url: "admin-card-blog", component: <CardBlog /> },
    { url: "dashboard-setting", component: <DashboardSettings /> },
    { url: "dashboard-transaction", component: <DashBoardEntries /> },
    { url: "withdraw-req", component: <WithdrawRequests /> },
    { url: "deposit-entry", component: <DepositEntry /> },
    ///// COIN ROUTES
    { url: "admin-coins", component: <CoinsTable /> },
    // {
    //   url: "admin-coins/manage-coin-price",
    //   component: <ManageCoinsPriceTable />,
    // },

    {
      url: "admin-coins/manage-coin-price/:coinId",
      component: <ManageCoinsPriceTable />,
    },
    // {
    //   url: "admin-settings",
    //   component: <Settings />,
    // },
    ///// TRASNACTIONS ROUTES
    { url: "admin-transactions", component: <TransactionsTable /> },
    // { url: "admin-promo-codes", component: <PromoCodesTable /> },
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route path="/login" element={<Login />} />
        <Route path="/page-register" element={<SignUp />} />
        <Route path="/page-forgot-password" element={<ForgotPassword />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
          {user?.userType == "admin" &&
            adminRoutes.map((data, i) => (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={data.component}
              />
            ))}
        </Route>
        <Route path="/*" element={<Error404 />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${menuToggle ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Markup;
